import { formatFields, formatPlans } from "./formatFormField";

export const getIntentStateDetails = ({
  actionData,
  intentSdkState,
  nextAction,
  currency,
}: {
  intentSdkState: IntentSdkState;
  actionData: PaymentActionData;
  nextAction: NextActions;
  currency: string;
}) => {
  const {
    form_fields,
    provider_name,
    provider_extra_data,
    iframe_url,
    provider_api_name,
  } = actionData;
  const { redirect, card_token_data } = actionData;

  // ApplePay MoneyHash hosted skip intermediate native pay loading, and redirect to ApplePay MoneyHash hosted page
  if (
    nextAction === "NATIVE_PAY" &&
    actionData?.is_merchant_hosted === false &&
    actionData?.js_sdk_url_to_render_enabled
  ) {
    return {
      url: iframe_url,
      renderStrategy: "REDIRECT" satisfies NextActions,
    };
  }

  switch (intentSdkState) {
    case "FORM_FIELDS":
      return {
        formFields: form_fields
          ? {
              billing: form_fields?.billing_fields?.length
                ? formatFields({
                    fields: form_fields.billing_fields,
                    providerName: provider_name,
                    providerExtraData: provider_extra_data,
                    providerApiName: provider_api_name,
                  })
                : null,
              shipping: form_fields?.shipping_fields?.length
                ? formatFields({
                    fields: form_fields.shipping_fields,
                    providerName: provider_name,
                    providerExtraData: provider_extra_data,
                    providerApiName: provider_api_name,
                  })
                : null,
              card: form_fields?.card_embed?.access_token
                ? {
                    accessToken: form_fields?.card_embed?.access_token,
                  }
                : null,
            }
          : null,
      };
    case "URL_TO_RENDER":
      return {
        url: redirect?.redirect_url || iframe_url,
        renderStrategy: nextAction,
      };
    case "SAVED_CARD_CVV":
      return {
        card: {
          brand: card_token_data?.brand,
          brandIconUrl: card_token_data?.logo,
          last4Digits: card_token_data?.last_4,
        },
        cvvField: {
          type: "text",
          name: "cvv",
          label: "CVV",
          hint: null,
          value: "",
          readOnly: false,
          validation: {
            required: true,
            minLength: 3,
            maxLength: 4,
          },
        },
      };
    case "INSTALLMENT_PLANS":
      return {
        plans: formatPlans({
          plans: actionData.plans,
          currency,
          providerRelatedFields: actionData.provider_related_fields,
        }),
      };
    default:
      return null;
  }
};
